function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import ClickAway from '../ClickAway';
import FocusTrap from '../FocusTrap';
import OpenableComponent from '../OpenableComponent';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The Dialog component is used to provide focus to a users
 * task or to inform a user of an important message or choice. All dialogs will
 * be "modal", meaning they will only allow interactions within it.
 *
 * - [SIE Web Getting Started - Accessible Modal Guide](https://github.sie.sony.com/SIE/psweb-getting-started/blob/ac26d8745d7944f5a7c6b573be9806ef13e31505/tutorials/accessibility/accessible-modal/README.md)
 * - [MDN aria role="dialog"](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/dialog_role)
 *
 * ## Composed of
 * - [ClickAway](../ClickAway/README.md)
 * - [FocusTrap](../FocusTrap/README.md)
 *
 * ## Usage
 *
 * ```
 * <div className="full-screen">
 *    <Dialog className="center">
 *       Dialog Content...
 *       <Button ctaType="primary">OK</Button>
 *       <Button ctaType="secondary" iconOnly>
 *          <Icon type="close" />
 *       </Button>
 *    </Dialog>
 * </div>
 * ```
 *
 * ## Props
 */

var Dialog = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(Dialog, _OpenableComponent);

  var _super = _createSuper(Dialog);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickAway", function (event) {
      event.stopPropagation();

      _this.close();
    });

    _this._node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var openOnMount = this.props.openOnMount;

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this2.open();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          variant = _this$props.variant,
          disableClickAway = _this$props.disableClickAway,
          includeWrapper = _this$props.includeWrapper;
      var isOpen = this.isOpen();

      var _Dialog$getClassName = Dialog.getClassName({
        className: className,
        isOpen: isOpen,
        variant: variant
      }),
          root = _Dialog$getClassName.root,
          dialog = _Dialog$getClassName.dialog;

      if (!isOpen) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: root
      }, /*#__PURE__*/React.createElement(ClickAway, {
        disabled: variant === 'bare' || disableClickAway,
        node: this._node,
        onClickAway: this.onClickAway
      }, /*#__PURE__*/React.createElement(FocusTrap, {
        node: this._node,
        onEscape: this.close,
        trap: this.isOpen(),
        includeWrapper: includeWrapper
      }, /*#__PURE__*/React.createElement("div", {
        ref: this._node,
        className: dialog,
        role: "dialog"
      }, children))));
    }
  }]);

  return Dialog;
}(OpenableComponent);

Dialog.defaultProps = {
  className: '',
  isOpen: null,
  disableClickAway: false,
  openOnMount: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  children: null,
  variant: 'standard',
  includeWrapper: false
};
Dialog.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * To disable click away behavior. This is done by default for bare variants
   */
  disableClickAway: PropTypes.bool,

  /**
   * To allow the component to be controlled, for use with UiLayers this is not needed
   */
  isOpen: PropTypes.bool,

  /**
   * To open the drawer when the component is mounted. This is needed when using the
   * drawer with UiLayers as the component will be mounted and unmounted once per open
   * close cycle
   */
  openOnMount: PropTypes.bool,

  /**
   * callback to be notified when the drawer is opened
   */
  onOpen: PropTypes.func,

  /**
   * event callback called when user presses ESC, or clicks outside of the dialog
   */
  onClose: PropTypes.func,

  /**
   * The dialog content
   */
  children: PropTypes.node,

  /**
   * The presentational variant
   * - bare presents the dialog content directly on the scrim
   * - standard presents the dialog content in a raised box
   */
  variant: PropTypes.oneOf(['standard', 'bare']),

  /**
   * This prop tell FocusWrap component whether to include a wrapping component or not.
   * A wrapping component is necessary when forwarding a ref. This prop was added to
   * disambiguate the default behavior which was to prefer not including a wrapping element in
   * favor of a previously established node.
   */
  includeWrapper: PropTypes.bool
};

Dialog.getClassName = function (_ref) {
  var className = _ref.className,
      variant = _ref.variant;
  return {
    root: cx('psw-l-full-screen'),
    dialog: cx(className, 'psw-dialog', "psw-".concat(variant, "-dialog"), 'psw-l-center', _defineProperty({}, cx('psw-c-bg-card-2'), variant === 'standard'), _defineProperty({}, cx('psw-c-bg-0'), variant === 'bare'))
  };
};

Dialog.useClassNames = function (classNames) {
  Dialog.classNames = classNames;
};

cx = classNamesFor(Dialog);
export default Dialog;